import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { IconComponent } from '@libs/components/icons';
import type { OrderHistoryRecordModel } from '@libs/services/models';
import { OrderStatusModel } from '@libs/shared/models';
import { LinkDirective, LuxonDatePipe, PriceVisibilityDirective } from '@libs/shared/ui';
import { OrderHistoryHelperService } from '../order-history-helper.service';
import { OrderHistoryStatusComponent } from '../order-history-status';

@Component({
  selector: 'ui-order-history-details',
  templateUrl: './order-history-details.component.html',
  styleUrls: ['./order-history-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.full-view]': 'displayFullView()',
  },
  imports: [
    DecimalPipe,
    IconComponent,
    LinkDirective,
    MatTooltip,
    OrderHistoryStatusComponent,
    PriceVisibilityDirective,
    LuxonDatePipe,
  ],
})
export class OrderHistoryDetailsComponent {
  public readonly helperService: OrderHistoryHelperService = inject(OrderHistoryHelperService);
  public displayFullView: InputSignal<boolean> = input(true);
  public order: InputSignal<OrderHistoryRecordModel> = input.required();
  public orderType: Signal<string> = computed((): string => this.helperService.OrderTypes[this.order().type] ?? this.order().typeDescription);
  public orderStatus: InputSignal<OrderStatusModel | undefined> = input();
  public orderLink: Signal<string> = computed((): string => this.helperService.orderLink(this.order()));
  public invoiceNumber: Signal<string> = computed((): string => this.helperService.invoiceNumber(this.order()));
  public orderNumber: Signal<string> = computed((): string => this.helperService.orderNumber(this.order()));
}
